import { Component } from "@angular/core";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController,
} from "ionic-angular";
import { Observable, BehaviorSubject } from "rxjs";
import { Constants } from "../../../../providers";
import { AuthService } from "../../../../providers/api/auth.service";
import { NodeAvailabilityProvider } from "../../../../providers/node-availability/node-availability";
import { ScenesService } from "../../../../providers/api/scenes.service";
import { Scene } from "../../../../models/scene.model";

/**
 * Generated class for the ScenesEditPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-scenes-edit",
  templateUrl: "scenes-edit.html",
})
export class ScenesEditPage {
  public sceneModel: Scene;
  public scene: any = {
    devices: [],
  };
  public localNodes: any;
  public lightNodes: any[] = [];
  public blindNodes: any[] = [];
  public awningNodes: any[] = [];
  public climaNodes: any[] = [];
  public userID: any;
  public validation_messages: any;
  public form: FormGroup;
  private ID: string;
  private editId = Constants.APP_KEY + ":edit-scene";
  private storageId: string;
  private isSceneLoaded: BehaviorSubject<boolean> = new BehaviorSubject<
    boolean
  >(false);

  constructor(
    private availability: NodeAvailabilityProvider,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    private auth: AuthService,
    public formBuilder: FormBuilder,
    private scenesService: ScenesService
  ) {
    this.form = this.formBuilder.group({
      name: ["", Validators.required],
    });
  }

  ionViewDidLoad() {
    let loader = this.loadingCtrl.create({
      content: "Loading devices...",
      dismissOnPageChange: false,
    });
    loader.present();
    if (this.auth.getAuthUser()) {
      this.userID = this.auth.getAuthUser()._id;
    }
    this.isSceneLoaded.subscribe((loaded) => {
      if (loaded) {
        Observable.zip(
          this.availability.getSpecificNodes("light"),
          this.availability.getSpecificNodes("blind"),
          this.availability.getSpecificNodes("awning"),
          this.availability.getSpecificNodes("clima")
        ).subscribe(
          ([lights, blinds, awnings, clima]) => {
            this.scene.devices = this.loadCurrentNodes(this.scene.devices);
            this.localNodes = this.scene.devices;
            this.lightNodes = lights;
            this.blindNodes = blinds;
            this.awningNodes = awnings;
            this.climaNodes = clima;
            loader.dismissAll();
          },
          (err) => {
            loader.dismissAll();
            console.log("error");
          }
        );
      }
    });
  }

  ionViewWillEnter() {
    this.storageId = localStorage.getItem(this.editId);
    if (this.storageId !== "undefined") {
      this.getScene();
    }
  }

  getScene() {
    if (this.storageId) {
      const sID = JSON.parse(this.storageId);
      this.ID = sID.id;
      this.scenesService.show(this.ID).subscribe(
        (res) => {
          this.scene = res;
          delete this.scene._id;
          delete this.scene.created_at;
          this.isSceneLoaded.next(true);
        },
        (err) => {
          console.log("Edit", err);
        }
      );
    }
  }

  loadCurrentNodes(nodes: any[]) {
    let actualNodes = {};

    nodes.forEach((node) => {
      actualNodes[node.id] = {
        id: node.id,
        available: node.available,
        active: node.active,
        endpoints: node.endpoints,
      };
    });
    return actualNodes;
  }

  changeState(deviceId, endpointId, active, onlyOne = false) {
    if (this.scene.devices[deviceId]) {
      for (let i = 0; i < this.scene.devices[deviceId].endpoints.length; i++) {
        if (this.scene.devices[deviceId].endpoints[i].id === endpointId) {
          this.scene.devices[deviceId].endpoints[i].defaultState = active;
          if (active) {
            this.scene.devices[deviceId].endpoints[
              i
            ].value = this.scene.devices[deviceId].endpoints[i].stateOn;
          } else {
            this.scene.devices[deviceId].endpoints[
              i
            ].value = this.scene.devices[deviceId].endpoints[i].stateOff;
          }
        } else if (onlyOne && active) {
          this.scene.devices[deviceId].endpoints[i].defaultState = false;
          this.scene.devices[deviceId].endpoints[i].value = this.scene.devices[
            deviceId
          ].endpoints[i].stateOff;
        }
      }
    }
  }

  changeAvailability(deviceId, available) {
    if (this.scene.devices[deviceId]) {
      console.log("scene available ", this.scene.devices[deviceId]);
      this.scene.devices[deviceId].available = available;
      for (let i = 0; i < this.scene.devices[deviceId].endpoints.length; i++) {
        this.scene.devices[deviceId].endpoints[i].defaultState = false;
        this.scene.devices[deviceId].endpoints[i].value = this.scene.devices[
          deviceId
        ].endpoints[i].stateOff;
      }
    }
  }

  update() {
    if (this.form.valid) {
      let data;
      const name = this.form.controls.name.value;
      delete this.scene._id;
      this.scene.name = name;
      this._setDevices(this.scene.devices);
      data = this.scene;
      this.scenesService.update(this.ID, data).subscribe(
        (res) => {
          this.navCtrl.setRoot("GlobalSettingsPage");
          this.navCtrl.push("ScenesPage");
        },
        (err) => {
          console.error("Updated error:::", err);
        }
      );
    }
  }

  _setDevices(devices: any) {
    let auxDevices = [];
    for (let id in devices) {
      auxDevices.push(devices[id]);
    }
    this.scene.devices = auxDevices;
  }
}



// WEBPACK FOOTER //
// ./src/pages/global-settings/scenes/scenes-edit/scenes-edit.ts